package fr.arcplex.network

import fr.arcplex.network.model.Film
import fr.arcplex.network.model.PlaybackSource
import fr.arcplex.network.model.RailItem
import fr.arcplex.network.model.Screen
import fr.arcplex.network.model.ScreenAction
import fr.arcplex.network.model.ScreenKind
import fr.arcplex.network.model.SearchPage
import fr.arcplex.network.model.Branding

/** Which renderer the UI must use for the film screen. */
enum class RendererKind {
    LEGACY,
    COHERENCE
}

/**
 * Everything the UI needs from the backend. Replacing the filmo/generique API
 * or the Coherence API means writing another implementation of this interface
 * inside `:APInetwork`; the Compose UI does not change.
 */
interface SoonerApi {
    /** Root screen (legacy getRootPage chain, or a future home endpoint). */
    suspend fun fetchRoot(): Result<Screen>

    /** Screen reached from an action URL (menu entries, promotional links). */
    suspend fun fetchScreen(actionUrl: String): Result<Screen>

    /** Film detail: Coherence payload when the backend has one, legacy screen as fallback. */
    suspend fun fetchFilm(filmId: String): Result<Film>

    /** Runs one search query against the current backend's search contract. */
    suspend fun search(actionUrl: String, query: String, validate: Boolean): Result<SearchPage>

    /** Cached branding (theme + labels). */
    suspend fun cachedBranding(): Branding

    /** Refreshes branding from the backend cache/network. */
    suspend fun refreshBranding(): Result<Branding>

    /** Resolves a poster/action into a DRM-ready playback descriptor. */
    suspend fun resolvePlayback(item: RailItem): Result<PlaybackSource>

    /** Which renderer the UI should use for the film screen. */
    val renderer: RendererKind

    /** Classifies a clicked item: open a film, play, open a screen, toggle menu, ignore. */
    fun resolveAction(item: RailItem, currentScreen: Screen?): ScreenAction
}
